import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { getLocalTranslate } from 'src/app/helpers/global-functions';
import { AuthService } from 'src/app/services/auth.service';
import { UploadService } from 'src/app/services/upload.service';

@Component({
  selector: 'app-update-photo',
  templateUrl: './update-photo.component.html',
  styleUrls: ['./update-photo.component.css']
})
export class UpdatePhotoComponent implements OnInit {

  updatePhotoText:string = 'Update Photo'
  chooseFile:string = 'Choose File'
  submit:string = 'Submit'

  form: FormGroup;
  loading = false;
  imageSrc:string | ArrayBuffer = 'assets/img/default-avatar.jpg';

  showSpinner: boolean;

  constructor(
    private fb: FormBuilder,
    private router:Router,
    private uploadService:UploadService,
    private authService:AuthService,
    private toastr: ToastrService,
    ) {
    this.form = this.fb.group({
      avatar: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.needTranslate();
  }

  needTranslate(){
    this.updatePhotoText = getLocalTranslate('update-photo',this.updatePhotoText)
    this.chooseFile = getLocalTranslate('choose-file',this.chooseFile)
    this.submit = getLocalTranslate('submit',this.submit)
 

  }

  onUpload():void{

  }

  onFileChange(files: FileList) {

    
    if (files && files.length > 0) {
      // For Preview
      const file = files[0];
      
  
      const outputImageAspectRatio = 1;

      const inputImage = new Image();

      inputImage.onload = () => {

        // let's store the width and height of our image
        const inputWidth = inputImage.naturalWidth;
        const inputHeight = inputImage.naturalHeight;

        // get the aspect ratio of the input image
        const inputImageAspectRatio = inputWidth / inputHeight;

        // if it's bigger than our target aspect ratio
        let outputWidth = inputWidth;
        let outputHeight = inputHeight;
        if (inputImageAspectRatio > outputImageAspectRatio) {
            outputWidth = inputHeight * outputImageAspectRatio;
        } else if (inputImageAspectRatio < outputImageAspectRatio) {
            outputHeight = inputWidth / outputImageAspectRatio;
        }


        // calculate the position to draw the image at
        const outputX = (outputWidth - inputWidth) * 0.5;
        const outputY = (outputHeight - inputHeight) * 0.5;

        console.log(outputX);
        console.log(outputY);

        // create a canvas that will present the output image
        const outputImage = document.createElement('canvas');

        // set it to the same size as the image
        outputImage.width = outputWidth;
        outputImage.height = outputHeight;

        // draw our image at position 0, 0 on the canvas
        const ctx = outputImage.getContext('2d');
        ctx.drawImage(inputImage, outputX, outputY);


        const src = outputImage.toDataURL("image/jpeg");
        const file = this.getFile(src);

        this.handleUpdateImage(src,file);
        
       
        console.log(this.form.invalid);

      };

      inputImage.src = URL.createObjectURL(file);

      this.form.setValue({avatar:file.name});
      
    }
  }



  get avatar() { return this.form.get('avatar') };

  onSubmit() {
    
    const src = this.imageSrc.toString();

    const result = confirm("Are you sure to upload this photo?");
    if (!result) {
      return;
    }

   

    this.upload(this.getFile(src));
    

  }

  getFile(src){

    const fileName = this.avatar.value;

    const file = this.dataURLtoFile(src,fileName);

    return file;
  }

  async upload(file){
    const randomId = Date.now();
    const uploadPath = "student-photos/" + randomId + ".jpeg";
    this.showSpinner = true;
    const downloadURL = await this.uploadService.upload(uploadPath, file).then(function (result) {
      return result.ref.getDownloadURL().then(function (downloadURL) {
        return downloadURL;
      })
    })

    await this.authService.updateAvatarUrl(downloadURL);

    this.showSpinner = false;
    if (downloadURL){

      this.toastr.success("Uploadeded image Successfully");
      setTimeout(() => {
        this.router.navigate(['my-account/courses']);
      }, 1500)
      console.log(downloadURL);
    }else{
      this.toastr.error("Upload image failed");
    }
  }

  dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  }

  fileSize(file:File):any{

    var _size = file.size;

    _size /= 1000;

    return _size;
  
  }

  handleUpdateImage(src:string | ArrayBuffer,file:File){
   
    const fileSize = this.fileSize(file);
    console.log(fileSize);

    if ( fileSize >= 100){
      this.imageSrc = 'assets/img/default-avatar.jpg';
      this.form.setValue({avatar:null});
      this.toastr.error("Image size must be lower than 100kb");
      return;
    }


    this.imageSrc = src;
    
  }
}
